import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../config';
import './AlertFeed.css';

const AlertFeed = () => {
  const navigate = useNavigate();
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchAlerts = async () => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/alerts`, {
        headers: {

        }
      });
      const data = await response.json();
      setAlerts(data);
    } catch (error) {
      console.error('Error fetching alerts:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAlerts();
    const interval = setInterval(fetchAlerts, 30000); // Poll every 30s
    return () => clearInterval(interval);
  }, []);

  const getSeverityClass = (severity) => {
    switch (severity.toLowerCase()) {
      case 'critical': return 'severity-critical';
      case 'warning': return 'severity-warning';
      default: return 'severity-info';
    }
  };

  return (
    <div className="alert-feed-container">
      <div className="alert-feed-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          <span className="back-icon">‹</span>
        </button>
        <h2 className="title">System Alerts</h2>
        <div style={{ width: 40 }}></div>
      </div>

      <div className="alert-list">
        {loading ? (
          <div className="empty-msg">Loading alerts...</div>
        ) : alerts.length > 0 ? (
          alerts.map((alert) => (
            <div key={alert.id} className="alert-card">
              <div className={`severity-indicator ${getSeverityClass(alert.severity)}`}></div>
              <div className="alert-content">
                <div className="alert-meta">
                  <span className="device-id">{alert.device_id}</span>
                  <span className="timestamp">
                    {new Date(alert.timestamp).toLocaleString([], { 
                      month: 'short', 
                      day: 'numeric', 
                      hour: '2-digit', 
                      minute: '2-digit' 
                    })}
                  </span>
                </div>
                <div className="event-type">{alert.event_type}</div>
                <div className="message">{alert.message}</div>
              </div>
            </div>
          ))
        ) : (
          <div className="empty-msg">No recent alerts detected.</div>
        )}
      </div>
    </div>
  );
};

export default AlertFeed;
